/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiSearchFilter } from './InternalApiSearchFilter';
import {
    InternalApiSearchFilterFromJSON,
    InternalApiSearchFilterFromJSONTyped,
    InternalApiSearchFilterToJSON,
    InternalApiSearchFilterToJSONTyped,
} from './InternalApiSearchFilter';
import type { InternalApiLogicalOperator } from './InternalApiLogicalOperator';
import {
    InternalApiLogicalOperatorFromJSON,
    InternalApiLogicalOperatorFromJSONTyped,
    InternalApiLogicalOperatorToJSON,
    InternalApiLogicalOperatorToJSONTyped,
} from './InternalApiLogicalOperator';
import type { InternalApiPersonCategory } from './InternalApiPersonCategory';
import {
    InternalApiPersonCategoryFromJSON,
    InternalApiPersonCategoryFromJSONTyped,
    InternalApiPersonCategoryToJSON,
    InternalApiPersonCategoryToJSONTyped,
} from './InternalApiPersonCategory';
import type { InternalApiExportFileType } from './InternalApiExportFileType';
import {
    InternalApiExportFileTypeFromJSON,
    InternalApiExportFileTypeFromJSONTyped,
    InternalApiExportFileTypeToJSON,
    InternalApiExportFileTypeToJSONTyped,
} from './InternalApiExportFileType';
import type { InternalApiSortDirection } from './InternalApiSortDirection';
import {
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionFromJSONTyped,
    InternalApiSortDirectionToJSON,
    InternalApiSortDirectionToJSONTyped,
} from './InternalApiSortDirection';

/**
 * 
 * @export
 * @interface InternalApiPersonExportQuery
 */
export interface InternalApiPersonExportQuery {
    /**
     * 
     * @type {string}
     * @memberof InternalApiPersonExportQuery
     */
    orderBy?: string;
    /**
     * 
     * @type {InternalApiSortDirection}
     * @memberof InternalApiPersonExportQuery
     */
    direction?: InternalApiSortDirection;
    /**
     * 
     * @type {Array<InternalApiSearchFilter>}
     * @memberof InternalApiPersonExportQuery
     */
    filters: Array<InternalApiSearchFilter>;
    /**
     * 
     * @type {InternalApiLogicalOperator}
     * @memberof InternalApiPersonExportQuery
     */
    logicalOperator: InternalApiLogicalOperator;
    /**
     * 
     * @type {InternalApiPersonCategory}
     * @memberof InternalApiPersonExportQuery
     */
    category: InternalApiPersonCategory;
    /**
     * 
     * @type {InternalApiExportFileType}
     * @memberof InternalApiPersonExportQuery
     */
    fileType: InternalApiExportFileType;
}



/**
 * Check if a given object implements the InternalApiPersonExportQuery interface.
 */
export function instanceOfInternalApiPersonExportQuery(value: object): value is InternalApiPersonExportQuery {
    if (!('filters' in value) || value['filters'] === undefined) return false;
    if (!('logicalOperator' in value) || value['logicalOperator'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    return true;
}

export function InternalApiPersonExportQueryFromJSON(json: any): InternalApiPersonExportQuery {
    return InternalApiPersonExportQueryFromJSONTyped(json, false);
}

export function InternalApiPersonExportQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPersonExportQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'orderBy': json['orderBy'] == null ? undefined : json['orderBy'],
        'direction': json['direction'] == null ? undefined : InternalApiSortDirectionFromJSON(json['direction']),
        'filters': ((json['filters'] as Array<any>).map(InternalApiSearchFilterFromJSON)),
        'logicalOperator': InternalApiLogicalOperatorFromJSON(json['logicalOperator']),
        'category': InternalApiPersonCategoryFromJSON(json['category']),
        'fileType': InternalApiExportFileTypeFromJSON(json['fileType']),
    };
}

export function InternalApiPersonExportQueryToJSON(json: any): InternalApiPersonExportQuery {
    return InternalApiPersonExportQueryToJSONTyped(json, false);
}

export function InternalApiPersonExportQueryToJSONTyped(value?: InternalApiPersonExportQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderBy': value['orderBy'],
        'direction': InternalApiSortDirectionToJSON(value['direction']),
        'filters': ((value['filters'] as Array<any>).map(InternalApiSearchFilterToJSON)),
        'logicalOperator': InternalApiLogicalOperatorToJSON(value['logicalOperator']),
        'category': InternalApiPersonCategoryToJSON(value['category']),
        'fileType': InternalApiExportFileTypeToJSON(value['fileType']),
    };
}

